import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToSection } from "../lib/scroll";
import { MobileMenu } from "./MobileMenu";

const LINKS = [
    { label: "Über mich", href: "#ueber-mich", testid: "nav-link-ueber-mich" },
    { label: "Beratung", href: "#beratung", testid: "nav-link-beratung" },
    { label: "Ablauf", href: "#ablauf", testid: "nav-link-ablauf" },
    { label: "Preise", href: "#preise", testid: "nav-link-preise" },
    { label: "Kontakt", href: "#kontakt", testid: "nav-link-kontakt" },
];

export const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > window.innerHeight - 90);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const go = (href) => {
        setOpen(false);
        scrollToSection(href);
    };

    const light = !scrolled && !open;
    let headerBg = "bg-transparent";
    if (open) headerBg = "bg-[#F4F1EA]";
    else if (scrolled) headerBg = "bg-[#F4F1EA]/92 backdrop-blur-md border-b border-[#DDD6C8]";

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${headerBg}`}
        >
            <div className="max-w-6xl mx-auto px-5 sm:px-8 lg:px-12">
                <div className="flex items-center justify-end h-[76px]">
                    <nav className="hidden lg:flex items-center gap-8">
                        {LINKS.map((l) => (
                            <button
                                key={l.href}
                                data-testid={l.testid}
                                onClick={() => go(l.href)}
                                className={`font-sans text-[13px] font-normal tracking-[0.08em] transition-colors duration-500 relative after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 after:transition-all after:duration-300 hover:after:w-full ${
                                    light
                                        ? "text-[#FAF8F5]/85 hover:text-[#FAF8F5] after:bg-[#FAF8F5]"
                                        : "text-[#59534C] hover:text-[#2B2825] after:bg-[#2B2825]"
                                }`}
                            >
                                {l.label}
                            </button>
                        ))}
                        <button
                            data-testid="nav-btn-cta-kennenlernen"
                            onClick={() => go("#kontakt")}
                            className={`ml-2 font-sans text-[12px] font-medium tracking-[0.15em] uppercase px-6 py-3 transition-all duration-500 border ${
                                light
                                    ? "border-[#FAF8F5]/50 text-[#FAF8F5] hover:bg-[#FAF8F5] hover:text-[#2B2825]"
                                    : "border-[#2B2825] bg-[#2B2825] text-[#FAF8F5] hover:bg-[#4A453F] hover:border-[#4A453F]"
                            }`}
                        >
                            Kennenlerngespräch
                        </button>
                    </nav>

                    <button
                        data-testid="nav-mobile-toggle"
                        className={`lg:hidden p-2 transition-colors duration-500 ${light ? "text-[#FAF8F5]" : "text-[#2B2825]"}`}
                        onClick={() => setOpen(!open)}
                        aria-label="Menü öffnen"
                    >
                        {open ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </div>
            </div>

            {open && <MobileMenu links={LINKS} onGo={go} />}
        </header>
    );
};
